import { render } from "./EventsSlider.vue?vue&type=template&id=381cc67c&scoped=true"
import script from "./EventsSlider.vue?vue&type=script&lang=js"
export * from "./EventsSlider.vue?vue&type=script&lang=js"

import "./EventsSlider.vue?vue&type=style&index=0&id=381cc67c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381cc67c"]])

export default __exports__